module.exports = __webpack_public_path__ + "static/npc-character-wheet-78f2536c2eb98bd567499530abfca874.pdf";